import axios from 'axios'

export const fetchRefunds = async(params = {}) => {
  try {
    return await axios.get('/refunds', { params })
  } catch (error) {
    throw error.response
  }
}

export const fetchRefundsResume = async() => {
  try {
    return await axios.get('/refunds/resume')
  } catch (error) {
    throw error.response
  }
}

export const fetchRefundsResumeByMonth = async(year, month) => {
  try {
    return await axios.get(`/refunds/resume-by-month/${year}/${month}`)
  } catch (error) {
    throw error.response
  }
}

export const fetchRefund = async(id) => {
  try {
    return await axios.get(`/refunds/${id}`)
  } catch (error) {
    throw error.response
  }
}

export const fetchRefundRescueCodes = async(id) => {
  try {
    return await axios.get(`/refunds/${id}/rescue-codes`)
  } catch (error) {
    throw error.response
  }
}
